import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { UnitSelect } from "../../Components/UnitSelect"
import { BlockField, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { DeleteButton } from "../../Components/DeleteButton"
import { NumberInput } from "../../Components/Input"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipDataItem } from "../../Components/ShipDataItem"
import { IShipDataGenerator } from "../../Types"
import { predefined } from "./Context"

interface ShipDataGeneratorViewProps {
  data: IShipDataGenerator;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeGenerator: () => void;
}

export function ShipDataGeneratorView({ data, editable, index, onEdited, removeGenerator }: ShipDataGeneratorViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `generators[${index}].`;

  { /* List for GeneratorTypes */ }
  // Initialize GeneratorType with the value from data, or undefined if not present
  const [generatorType, setGeneratorType] = useState<string | undefined>(data.generatorType);
  const predefinedGeneratorTypes = predefined.generatorType;
  const selectGeneratorType = useCallback((value?: string) => {
    setGeneratorType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  { /* List for fuelTypes */ }
  // Initialize fuelType with the value from data, or undefined if not present
  const [fuelType, setFuelType] = useState<string | undefined>(data.fuelType);
  const predefinedTypes = ["diesel", "petrol", "gas", "electricity"];
  const selectFuelType = useCallback((value?: string) => {
    setFuelType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipDataItem namePrefix={namePrefix} id={data.id}>
      <BlockRow className="block-row-1">
        <BlockField label={t("generator")} className="block_field_small_18">
          <PredefinedSelect value={generatorType} predefined={predefinedGeneratorTypes} label={(v) => t(`generator_${v}`)} customValue={t("other")} name={`${namePrefix}generatorType`} onSelect={selectGeneratorType} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("manufacturer")} className="block_field_small_24">
          <input name={`${namePrefix}manufacturer`} defaultValue={data.manufacturer} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("model")}>
          <input name={`${namePrefix}model`} defaultValue={data.model} onChange={onEdited} readOnly={!editable} />
        </BlockField>
      </BlockRow>

      <BlockRow className="block-row-last">
        <BlockField label={t("serial_number")} className="block_field_small_12">
          <input name={`${namePrefix}serialNumber`} defaultValue={data.serialNumber} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("power")} className="block_field_small_8">
          <BlockFieldInputs>
            <NumberInput format="int" className="unit" name={`${namePrefix}power`} defaultValue={data.power} onChange={onEdited} readOnly={!editable} />
            <UnitSelect kind="power" name={`${namePrefix}powerUnit`} value={data.powerUnit} editable={editable} onChange={onEdited} />
          </BlockFieldInputs>
        </BlockField>
        <BlockField label={t("fuel_type")} className="block_field_small_12">
          <PredefinedSelect value={fuelType} predefined={predefinedTypes} label={(v) => t(`fuel_${v}`)} customValue={t("other")} name={`${namePrefix}fuelType`} onSelect={selectFuelType} readOnly={!editable} />
        </BlockField>

        <BlockField label={t("comment")}>
          <input name={`${namePrefix}comment`} defaultValue={data.comment} onChange={onEdited} readOnly={!editable} />
        </BlockField>

        <DeleteButton onClick={removeGenerator} />
      </BlockRow>
    </ShipDataItem>
  );
}
